export const EXPAND_SIDE_MENU = 'EXPAND_SIDE_MENU'
export const COLLAPSE_SIDE_MENU = 'COLLAPSE_SIDE_MENU'